@if (questions && questions.length > 0) {
<div class="table-column-toggle">
  <div class="ui floating dropdown" (clickOutside)="hideDropdown()">
    <button
      class="ui compact icon button"
      [ngClass]="{ selected: showDropdown }"
      (click)="toggleDropdown()"
    >
      <i class="eye slash outline icon"></i>
    </button>
    @if (showDropdown) {
    <div class="menu">
      @for (question of questions; track question) { @if (!question.hidden) {
      <label class="item" title="{{ question.question }}">
        <input type="checkbox" [(ngModel)]="question.toggleOff" /> &nbsp; @if
        (showQuestionId) {
        <span>{{ question.id }}.</span>
        } {{ question.question }}
      </label>
      } }
    </div>
    }
  </div>
</div>
}
